var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"show-tag-columns":"","show-tag-columns2":"","export-data-options":_vm.exportDataOptions,"showSearchbox":_vm.showSearchbox,"showGroupActions":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }